import { UpdateShipmentAmountBody } from '@core/models/shipment.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ShipmentsService {
    private readonly getShipmentsURL = `/shipments/1`;
    private readonly updateShipmentURL = `/shipments/add/amount`;

    // ---------------------------------------------------------------

    getShipments() {
        return fetchWithRetry(API.get(this.getShipmentsURL));
    }

    updateShipment(body: UpdateShipmentAmountBody) {
        return fetchWithRetry(API.patch(this.updateShipmentURL, body));
    }
}

export default new ShipmentsService();
